import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: 'Ho recuperato i miei weekend! In 5 minuti so già cosa cucinare e la spesa non è più un incubo.',
  name: 'Giulia M.',
  city: 'Milano'
}, {
  text: 'Non è una dieta, è libertà. Mi sento sgonfia e piena di energia dopo anni di tentativi falliti.',
  name: 'Francesca R.',
  city: 'Napoli'
}, {
  text: 'Il Meal Prep mediterraneo è la svolta. Lavoro 10 ore al giorno e ora mangio meglio di prima.',
  name: 'Marco E.',
  city: 'Torino'
}];
export function Testimonials() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-sage-light" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-5 sm:mb-8" data-id="element-204">
          <h2 className="text-xl sm:text-3xl font-serif font-bold text-brand-text-main mb-3 sm:mb-4" data-id="element-205">
            💬 COSA DICONO CHI LO HA GIÀ PROVATO
          </h2>
        </motion.div>

        <div className="space-y-3 sm:space-y-4" data-id="element-206">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white border border-brand-sage/30 p-5 sm:p-6 rounded-xl shadow-sm" data-id="element-207">
              <div className="flex items-center gap-2 mb-3" data-id="element-208">
                <div className="flex text-brand-gold" data-id="element-209">
                  {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-210" />)}
                </div>
              </div>
              <p className="text-brand-text-main font-medium mb-3 sm:mb-4 text-sm sm:text-base leading-snug" data-id="element-211">
                "{t.text}"
              </p>
              <div className="border-t border-brand-sage/10 pt-3" data-id="element-212">
                <span className="text-xs sm:text-sm text-brand-text-muted font-bold" data-id="element-213">
                  {t.name} ({t.city})
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}